import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-content.scss";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {CustomerPopup} from "../../../../panel/components/components/customer/popup/types/CustomerPopup";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteBlackAllieComponent} from "../black/allie/WebsiteBlackAllieComponent";
import {WebsiteBlackPlatformComponent} from "../black/platform/WebsiteBlackPlatformComponent";

export class WebsiteContentAnalysisComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.viewRankingFree"),
                            center: true,
                            title: Resources.t("words.indicatorsGiveEdge"),
                            description: Resources.t("words.sedestralTrackingDescription"),
                            background: "charts"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            contents: [
                                {
                                    name: Resources.t("words.positionTracking"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-am.mp4"),
                                    duration: 18000
                                },
                                {
                                    name: Resources.t("words.competitorAnalysis"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-al.mp4"),
                                    duration: 16000
                                }
                            ],
                            center: true
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPlatformComponent({
                            description: Resources.t("words.sedestralSeoOverview"),
                            grid: {
                                lines: [{
                                    entries: [{
                                        title: Resources.t("words.positionTracking"),
                                        description: Resources.t("words.trackContentPerformance"),
                                        type: "image",
                                        image: NetworkVendor.image("blog-w.webp"),
                                        titleIcon: "position",
                                        size: "sizeHalf",
                                    }, {
                                        title: Resources.t("words.googleRanking"),
                                        description: Resources.t("words.trackKeywordPerformance"),
                                        type: "image",
                                        image: NetworkVendor.image("blog-v.webp"),
                                        titleIcon: "google",
                                        size: "sizeLarge",
                                        color: "colorYellow",
                                    }]
                                }]
                            }
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackAllieComponent())}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        CustomerPopup.blog();
        super.commit();
    }
}

